import { Box, Divider } from "@mui/material";
import React from "react";
import { VeTypography } from "../../mui";
import "./Form.scss";

interface FormOptions {
  border: boolean;
  icon?: JSX.Element;
  Alert?: JSX.Element | null;
  children?:
    | React.ReactNode
    | React.ReactElement
    | (React.ReactElement | null)[];
  style?: React.CSSProperties;
  UnderButton?: React.ReactElement;
  heading?: string;
  UnderHeading?: boolean;
  marginBottom?: string;
}

export function AuthForm({
  border,
  icon,
  children,
  Alert,
  style,
  UnderButton,
  heading,
  UnderHeading, // Default spacing B/W heading and desc = 32 , if true makes it 16px
  marginBottom,
}: FormOptions) {
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        sx={{ ...style }}
        className={`form ${border && "form-border"}`}
      >
        {icon}
        {heading && (
          <Box
            marginTop={"32px"}
            marginBottom={
              marginBottom || (UnderHeading && UnderHeading ? "16px" : "32px")
            }
            textAlign={'center'}
          >
            <VeTypography variant="title3Main" textAlign={'center'}>{heading}</VeTypography>
          </Box>
        )}
        {children}
        {/* Use this to display anything under the button inside the box */}
        {UnderButton}
        {Alert}
      </Box>
      <Box
        sx={{
          display: "none",
          padding: "0 24px",
          "@media screen and (max-width:600px)": {
            display: "block",
          },
        }}
      >
        <Divider />
      </Box>
    </>
  );
}
